import _ from "lodash";

const toList = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
};

/**
 * Builds the campaign level locations ({ contexts, locations }) from the
 * unique locations found in the entities that hold them:
 * - platformsData.{platform}.locations (platforms with campaign level
 *   locations, e.g. google)
 * - adsGroups[].locations (platforms with ad group level locations, e.g. meta)
 *
 * Returns null when no entity has locations.
 */
export const getCampaignLocationsFromEntities = (campaign) => {
  const platformLocations = toList(campaign?.platformsData).flatMap(
    (platformData) => toList(platformData?.locations)
  );
  const adGroupLocations = toList(campaign?.adsGroups).flatMap((adGroup) =>
    toList(adGroup?.locations)
  );

  const unique = _.uniqBy(
    [...platformLocations, ...adGroupLocations].filter(
      (location) => location?.name
    ),
    (location) => location.id || location.name
  );
  if (unique.length === 0) return null;

  return {
    contexts: _.uniq(unique.map((location) => location.name)),
    locations: unique.map(({ id = "", name }) => ({
      id,
      name,
      longName: name,
      type: "specific",
    })),
  };
};
